import { GlTooltipDirective } from '@gitlab/ui';
import ItemMilestone from '~/issuable/components/issue_milestone.vue';
import WorkItemRolledUpCount from '~/work_items/components/work_item_links/work_item_rolled_up_count.vue';
import { WIDGET_TYPE_MILESTONE, WIDGET_TYPE_HIERARCHY, METADATA_KEYS } from '~/work_items/constants';
import WorkItemParentMetadata from '~/work_items/components/shared/work_item_parent_metadata.vue';
export default {
    name: 'WorkItemLinkChildMetadata',
    components: {
        ItemMilestone,
        WorkItemRolledUpCount,
        WorkItemParentMetadata
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        reference: {
            type: String,
            required: true
        },
        metadataWidgets: {
            type: Object,
            required: false,
            default: ()=>({})
        },
        hiddenMetadataKeys: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        // eslint-disable-next-line vue/no-unused-properties -- Used by EE component extension
        namespacePath: {
            type: String,
            required: false,
            default: ''
        }
    },
    computed: {
        milestone () {
            return this.metadataWidgets[WIDGET_TYPE_MILESTONE]?.milestone;
        },
        hierarchyWidget () {
            return this.metadataWidgets[WIDGET_TYPE_HIERARCHY];
        },
        showRolledUpCounts () {
            return this.hierarchyWidget && this.rolledUpCountsByType.length > 0;
        },
        rolledUpCountsByType () {
            return this.hierarchyWidget?.rolledUpCountsByType || [];
        },
        showMilestone () {
            return this.milestone && !this.hiddenMetadataKeys.includes(METADATA_KEYS.MILESTONE);
        },
        parentWorkItem () {
            return this.hierarchyWidget?.parent;
        },
        showParent () {
            return this.parentWorkItem && !this.hiddenMetadataKeys.includes(METADATA_KEYS.PARENT);
        }
    }
};
